<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.75 17C3.23122 17 2 15.7688 2 14.25V5.75C2 4.23122 3.23122 3 4.75 3H15.25C16.7688 3 18 4.23122 18 5.75V14.25C18 15.7688 16.7688 17 15.25 17H4.75ZM3.5 5.75C3.5 5.05964 4.05964 4.5 4.75 4.5H6.5V15.5H4.75C4.05964 15.5 3.5 14.9404 3.5 14.25V5.75ZM12 15.5H8V4.5H12V15.5ZM13.5 15.5H15.25C15.9404 15.5 16.5 14.9404 16.5 14.25V5.75C16.5 5.05964 15.9404 4.5 15.25 4.5H13.5V15.5Z"
            fill="currentColor"
        />
    </svg>
</template>
